import { getProxyUrl } from '.'

export async function getTexture(catalog: string, idTextura: number) {
  const url = getProxyUrl('api/Texturas/gettextura/')
  if (!catalog || !idTextura) return ''
  const params = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  } satisfies RequestInit

  try {
    const data = await fetch(url + catalog + '/' + idTextura, params)
    if (data.ok) {
      const json = await data.json()

      return json as string
    } else {
      return ''
    }
  } catch (e: any) {
    console.error(e as Error)
  }
}
